import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'shared.PromoBanner.SponsoringPromoBanner.title',
    defaultMessage:
      "Grâce à {sponsorFirstName}, les frais d'accompagnement vous sont offerts ! 🎁",
  },
});
